import { DefaultNamespace, TFunction } from "i18next";
import { PaidFor } from "@jobrad-gmbh/bike-leasing-calculator";
import { companyPaysEverything, getLabelForInspection } from "../state";
export type BuildCompanyPaysLabelFunction = (
  t: TFunction<DefaultNamespace, undefined>,
  companyPays: PaidFor | undefined,
) => string;

export const buildCompanyPaysLabel: BuildCompanyPaysLabelFunction = (
  t: TFunction<DefaultNamespace, undefined>,
  companyPays: PaidFor | undefined,
): string => {
  if (companyPaysEverything(companyPays)) {
    return t("infoBubbles.employerPaidCosts.2");
  }

  const labelForInspection = getLabelForInspection(t, companyPays);
  const labelForInsurance = t("insuranceAndBreakdownAssistance");

  const serviceLabelArray = [];
  if (labelForInspection) {
    serviceLabelArray.push(labelForInspection);
  }
  if (companyPays?.insurance) {
    serviceLabelArray.push(labelForInsurance);
  }
  return serviceLabelArray.join(", ");
};
